const SET_PHONE_CODES = (state, items) => {
  state.phoneCodes = items
}

const SET_PHONE_CODE = (state, item) => {
  state.newPhoneCode = item
}

const SET_EMPTY_PHONE_CODE = (state) => {
  state.newPhoneCode = {}
}

const SET_PHONE_CODE_PROPERTY = (state, item) => {
  if (state.newPhoneCode !== null) {
    Object.assign(state.newPhoneCode, item)
  }
}

const SET_ARTICLE = (state, item) => {
  state.newArticle = item
}

const SET_EMPTY_ARTICLE = (state) => {
  state.newArticle = {}
}

const SET_ARTICLE_PROPERTY = (state, item) => {
  if (state.newArticle !== null) {
    Object.assign(state.newArticle, item)
  }
}

const SET_ARTICLE_LOCALE = (state, locale) => {
  state.newArticle.locale = locale
}

const SET_ARTICLE_CATEGORY = (state, category) => {
  state.newArticle.category = category
}

const SET_NO_INDEX = (state, noIndex) => {
  state.newArticle.noIndex = noIndex
}

const SET_ARTICLES = (state, items) => {
  state.articles = items
}

export default {
  SET_PHONE_CODES,
  SET_PHONE_CODE,
  SET_EMPTY_PHONE_CODE,
  SET_PHONE_CODE_PROPERTY,

  SET_ARTICLE,
  SET_EMPTY_ARTICLE,
  SET_ARTICLE_PROPERTY,
  SET_ARTICLE_LOCALE,
  SET_ARTICLE_CATEGORY,
  SET_NO_INDEX,
  SET_ARTICLES
}



// WEBPACK FOOTER //
// ./src/store/modules/icg/mutations.js